/**
 * Device Dashboard Last Operation Timezone Cell
 * @description Shows short timezone (e.g. GMT-3) for the device's last operation
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { DeviceDashboardTableData } from '@/types/operational-ui.types';
import { formatTimezoneShort } from '@/utils/formatters/timezoneFormatter';

export const DeviceDashboardLastOperationTzCell = (
  _context: CellContext<DeviceDashboardTableData, string | undefined>
) => {
  const tz = _context.row.original.lastOperationTz ?? 'UTC';
  return <span className="text-xs text-gray-600">{formatTimezoneShort(tz)}</span>;
};
